// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e748241","239":"9180e550","667":"1eb32c03"}[chunkId] + ".chunk.js";
};